
import { FirmWareLogActions, FirmWareLogActionTypes } from '../actions/firm-ware-log.actions';
import {FirmWareLog} from '../firm-ware.model';

export interface State {
  Loaded: boolean;
  Loading: boolean;
  entities: FirmWareLog[];
}

export const initialState: State = {
  Loaded: false,
  Loading: false,
  entities: []
};

export function reducer(state = initialState, action: FirmWareLogActions): State {
  switch (action.type) {

    case FirmWareLogActionTypes.GetFirmWareLogs:
      return {...state, Loaded: false, Loading: true};

    case FirmWareLogActionTypes.LoadFirmWareLogs:
      return {...state, Loaded: true, Loading: false, entities: action.payload};

    case FirmWareLogActionTypes.GetFirmWareLogsFail:
      return {...state, Loaded: true, Loading: false};

    case FirmWareLogActionTypes.GetFirmwareMgtLogs:
      return {...state, Loaded: false, Loading: true};

    case FirmWareLogActionTypes.LoadFirmwareMgtLogs:
      return {...state, Loaded: true, Loading: false, entities: action.payload};

    case FirmWareLogActionTypes.GetFirmwareMgtLogsFail:
      return {...state, Loaded: true, Loading: false};

    default:
      return state;
  }
}
